export const ZOOM_IN_STEP_ON_EXPAND = 0.5

export const ZOOM_STEP = 0.25

export const MIN_ZOOM_LEVEL = 1

export const MAX_ZOOM_LEVEL = 3
